module.exports = __webpack_public_path__ + "static/media/2019---Overall-Quality-(Observed)-(1).a0ca1daf.png";